__turbopack_context__.v({
  "body": "EmeraldArcSection-module__dtImmW__body",
  "filmCard": "EmeraldArcSection-module__dtImmW__filmCard",
  "filmLayer": "EmeraldArcSection-module__dtImmW__filmLayer",
  "filmVideoFill": "EmeraldArcSection-module__dtImmW__filmVideoFill",
  "intro": "EmeraldArcSection-module__dtImmW__intro",
  "introStack": "EmeraldArcSection-module__dtImmW__introStack",
  "modalContent": "EmeraldArcSection-module__dtImmW__modalContent",
  "modalPortrait": "EmeraldArcSection-module__dtImmW__modalPortrait",
  "outer": "EmeraldArcSection-module__dtImmW__outer",
  "stage": "EmeraldArcSection-module__dtImmW__stage",
  "storePill": "EmeraldArcSection-module__dtImmW__storePill",
  "storeRow": "EmeraldArcSection-module__dtImmW__storeRow",
  "title": "EmeraldArcSection-module__dtImmW__title",
  "watchPill": "EmeraldArcSection-module__dtImmW__watchPill",
});
